__turbopack_context__.v({
  "amountContainer": "DonationListItem-module__U5CG3q__amountContainer",
  "card": "DonationListItem-module__U5CG3q__card",
  "comment": "DonationListItem-module__U5CG3q__comment",
  "commentContainer": "DonationListItem-module__U5CG3q__commentContainer",
  "ctaAmountContainer": "DonationListItem-module__U5CG3q__ctaAmountContainer",
  "ctaContainer": "DonationListItem-module__U5CG3q__ctaContainer",
  "expanded": "DonationListItem-module__U5CG3q__expanded",
  "heading": "DonationListItem-module__U5CG3q__heading",
  "showMoreButton": "DonationListItem-module__U5CG3q__showMoreButton",
  "timestamp": "DonationListItem-module__U5CG3q__timestamp",
});
